import merge from 'lodash/merge';
import {
    SET_NEW_DATA,
    SET_SEARCH_MAP_INSTANCE,
    SET_ZOOM
} from './search-actions';
import {
    GET_SPOTS_RADIAL,
    RADIAL_SPOTS_INCREMENT,
    GET_SPOTS_TILED,
    TILED_SPOTS_INCREMENT
} from './spots-actions';

const initialState = {
    isPending: true,
    data: {
        searchType: 'address',
        currentPage: 'map',
        currentIncrement: 0,
        zoom: 15,
        isDefaultTimes: true,
        source: 'widget',
        destinationTitle: 'Destination',
        searchedDestination: null,
        selectedEvent: null,
        showMapLink: false,
        venueId: null,
        eventId: null,
        eventFallback: null,
        isSingleEvent: false,
        kmlMapLayerEnabled: false,
        kmlMapLayerURL: null,
        searchMapInstance: null,
        geolocated: false,
        params: {
            monthly: false,
            starts: null,
            ends: null,
            monthly_start_date: null,
            latitude: 41.8808377,
            longitude: -87.6242212,
            places_id: null,
            places_place_id: null,
            places_reference: null,
            segment_id: null,
            distance__lt: 1609,
            distance__gt: null,
            search_string: null,
            original_search_string: null,
            users_latitude: null,
            users_longitude: null,
            eid: null,
            operator_id: null
        }
    },
    error: null
};
let currentStarts = null;
let currentEnds = null;

export default function search(state = initialState, {type, payload, meta}) {
    switch (type) {
        case SET_NEW_DATA: {
            const {
                data: {
                    params: {
                        starts,
                        ends
                    }
                }
            } = state;
            const isDefaultTimes = (currentStarts)
                ? (currentStarts !== starts || currentEnds !== ends)
                : true;

            currentStarts = starts;
            currentEnds = ends;

            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload.data,
                    isDefaultTimes,
                    params: {
                        ...state.data.params,
                        ...payload.params
                    }
                }
            };
        }

        case `${GET_SPOTS_RADIAL}_PENDING`: {
            return merge({}, state, {
                data: {
                    requestIncrements: meta.numRequests,
                    currentIncrement: 1,
                    searchedDestination: null
                },
                isPending: true,
                error: null
            });
        }

        case `${GET_SPOTS_RADIAL}_FULFILLED`: {
            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: 0
                }
            });
        }

        case `${GET_SPOTS_RADIAL}_REJECTED`: {
            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: 0
                },
                error: payload
            });
        }

        case RADIAL_SPOTS_INCREMENT: {
            if (payload.length) {
                window.currentCityTimezone = payload[0].facility.timezone;
            }

            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: state.data.currentIncrement + 1,
                    searchedDestination: meta
                },
                error: null
            });
        }

        case `${GET_SPOTS_TILED}_PENDING`: {
            return merge({}, state, {
                data: {
                    requestIncrements: meta.numRequests,
                    currentIncrement: 1
                },
                isPending: true,
                error: null
            });
        }

        case `${GET_SPOTS_TILED}_FULFILLED`: {
            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: 0
                }
            });
        }

        case `${GET_SPOTS_TILED}_REJECTED`: {
            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: 0
                },
                error: payload
            });
        }

        case TILED_SPOTS_INCREMENT: {
            return merge({}, state, {
                isPending: false,
                data: {
                    currentIncrement: state.data.currentIncrement + 1
                },
                error: null
            });
        }

        case SET_SEARCH_MAP_INSTANCE: {
            return merge({}, state, {
                data: {
                    searchMapInstance: payload.searchMapInstance
                }
            });
        }

        case SET_ZOOM: {
            return merge({}, state, {
                data: {
                    zoom: payload.zoom
                }
            });
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./widget/src/js/common/search-reducer.js